import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { AppComponent } from 'src/app/app.component';
import { LanguageService } from 'src/app/services/language.service';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import SwiperCore, { SwiperOptions,Pagination,Navigation, Swiper } from 'swiper';
import { SwiperComponent } from 'swiper/angular';

import { ModalController } from '@ionic/angular';
import { Preferences } from '@capacitor/preferences';
import { PlatformService } from 'src/app/platform.service';
SwiperCore.use([Pagination,Navigation ]);
@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.page.html',
  styleUrls: ['./welcome.page.scss'],
})
export class WelcomePage implements OnInit {
  activeIndex
  showGetStarted=false;
  getStartedref;
  @ViewChild('swiper', { static: false }) swiper: SwiperComponent;
  slides: Swiper;
  config: SwiperOptions = {
    slidesPerView: 1,
    pagination:{clickable:false},
    allowSlideNext:false,
    allowSlidePrev:false
  };
  constructor(
    public platformSRV:PlatformService,
    public modalController: ModalController,
    private dataSRV:DataService,
    private router: Router,
    public appComp:AppComponent,
  ) { }
  setSwiperInstance(swiper) {
    this.slides = swiper;
    this.activeIndex= this.slides.activeIndex
    }
    skipSlides(){
      this.slides.allowSlideNext=true
    this.slides.slideTo(2)
    this.slides.allowSlideNext=false
    }
  nextSlide(){
   this.slides.allowSlideNext=true
    this.slides.slideTo(this.slides.activeIndex+1)
    this.slides.allowSlideNext=false
    
  }
  // previousSlide(){
    
  //   this.slides.slideTo(this.slides.activeIndex-1)
    
  // }
  ionViewWillEnter(){
   
  }
  onSlideChange(ev) {  
    this.activeIndex= this.slides.activeIndex
  }
  ngOnInit() {
    
  }
  

  // getStarted(){
  //   Preferences.set({
  //     key:"newUser",
  //     value:JSON.stringify({
  //       stepOneComplete:true,
  //       stepTwoComplete:false
  //     })
  //   }).then(()=>{
  //     this.router.navigateByUrl('/login')
  //   })
  // }
  async getStarted() {
    this.dataSRV.storeData("newUser",{stepOneComplete:true,
      stepTwoComplete:false})
    
   .then(()=>{
      this.router.navigateByUrl('/chooseclient')
    })

    
  }
}
